import {PlayerColorWithoutNone} from '../../utils/gameColors'
import {useGameStore} from '../GameStoreContext'

export const useMyPerspectiveColor = (): PlayerColorWithoutNone => {
    const myColor = useGameStore((state) => state.myColor)
    const firstPlayerColor = useGameStore((state) => state.gameDetails.playOrder[0])
    const isMyColorSpectator = useGameStore((state) => state.isMyColorSpectator)
    if(isMyColorSpectator) return firstPlayerColor as PlayerColorWithoutNone
    return myColor as PlayerColorWithoutNone
}
